import { api, http } from '@/api/client'
import type { ApiItem } from '@/types/api'
import type { CurrentUser, LoginInput, SchoolSummary, Session } from './types'

// Concurrent refresh calls (StrictMode double effects, parallel 401s) share one request, so the
// rotating refresh cookie is only presented once.
let refreshInFlight: Promise<Session> | null = null

function refreshOnce(): Promise<Session> {
  refreshInFlight ??= http
    .post<ApiItem<Session>>('/auth/refresh')
    .then((r) => r.data.data)
    .finally(() => {
      refreshInFlight = null
    })
  return refreshInFlight
}

export const authApi = {
  login: (input: LoginInput) => api.post<Session>('/auth/login', input),
  /** Uses the HttpOnly refresh cookie. */
  refresh: refreshOnce,
  logout: () => api.post<null>('/auth/logout'),
  me: () => api.get<{ user: CurrentUser; school: SchoolSummary }>('/auth/me'),
  updateProfile: (input: { name: string; phone: string | null }) => api.put<CurrentUser>('/auth/me', input),
  changePassword: (input: { currentPassword: string; newPassword: string }) =>
    api.put<null>('/auth/password', input),
  updatePreferences: (input: { locale: string; theme: string }) =>
    api.put<CurrentUser>('/auth/me/preferences', input),
}

export interface Branding {
  school: SchoolSummary | null
  portals: { key: string; label: string }[]
}

export const fetchBranding = () => api.get<Branding>('/public/branding')
